import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store';

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'Home',
        description: 'Liste all the clients for an admin.',
        component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue')
    },
    {
        path: '/:client',
        name: 'Client',
        description: 'Liste all available services for a client.',
        component: () => import(/* webpackChunkName: "services" */ '../views/Services.vue')
    },
    {
        path: '/:client/deliveries',
        name: 'deliveries/Home',
        description: 'Deliveries homepage for a client.',
        component: () => import(/* webpackChunkName: "deliveries/home" */ '../views/deliveries/Home.vue')
    },
    {
        path: '/:client/trackandtrace',
        name: 'trackandtrace/Home',
        description: 'Track and trace homepage for a client.',
        component: () => import(/* webpackChunkName: "trackandtrace/home" */ '../views/trackandtrace/Home.vue')
    },
    {
        path: '/:client/trackandtrace/shipment',
        name: 'trackandtrace/Shipment',
        description: 'Track and trace informations of a shipment (details / events / contents / documents).',
        component: () => import(/* webpackChunkName: "trackandtrace/shipment" */ '../views/trackandtrace/Shipment.vue')
    },
    {
        path: '/:client/OSOL/trackandtrace/shipment',
        name: 'trackandtrace/Shipment',
        description: 'Track and trace informations of a shipment (details / events / contents / documents).',
        component: () => import(/* webpackChunkName: "trackandtrace/shipment" */ '../views/trackandtrace/Shipment.vue')
    },
    {
        path: '/:client/docs',
        name: 'Docs',
        description: 'Docs homepage.',
        component: () => import(/* webpackChunkName: "docs" */ '../views/docs/Home.vue')
    },
    {
        path: '/:client/BI',
        name: 'BI',
        description: 'BI homepage.',
        component: () => import(/* webpackChunkName: "BI" */ '../views/BI/Home.vue')
    },
    {
        path: '/:client/BI/:dashboard',
        name: 'BI/dashboard',
        description: 'BI Dashboard page.',
        component: () => import(/* webpackChunkName: "BI" */ '../views/BI/Dashboard.vue')
    },
    {
        path: '/:client/BPM',
        name: 'BPM',
        description: 'BPM homepage.',
        component: () => import(/* webpackChunkName: "BPM" */ '../views/BPM/Home.vue')
    },
    {
        path: '/:client/BPM/:dashboard',
        name: 'BPM/dashboard',
        description: 'BPM Dashboard page.',
        component: () => import(/* webpackChunkName: "BPM" */ '../views/BPM/Dashboard.vue')
    },
    {
        path: '/:client/IFRAME/:serviceNumber',
        name: 'IFRAME',
        description: 'IFRAME homepage.',
        component: () => import(/* webpackChunkName: "IFRAME" */ '../views/IFRAME/Home.vue')
    },
    {
        path: '/:client/IFRAME/:serviceNumber/:instanceId',
        name: 'IFRAME/dashboard',
        description: 'IFRAME Dashboard page.',
        component: () => import(/* webpackChunkName: "IFRAME" */ '../views/IFRAME/Dashboard.vue')
    },
    {
        path: '/:client/genericsearch/',
        name: 'Generic search',
        description: 'Generic search homepage.',
        component: () => import(/* webpackChunkName: "genericsearch" */ '../views/genericsearch/Home.vue')
    },
    {
        path: '/:client/genericsearch/:id',
        name: 'Generic search portlet',
        description: 'Generic search portlet page.',
        component: () => import(/* webpackChunkName: "genericsearch" */ '../views/genericsearch/Portlet.vue')
    },
    {
        path: '/:client/Statistic',
        name: 'Statistic',
        description: 'Statistic homepage.',
        component: () => import(/* webpackChunkName: "Statistic" */ '../views/Statistic/Home.vue')
    },
    {
        path: '/login/sso',
        name: 'LoginSSO',
        description: 'Login to the SSO.',
        beforeEnter() {
            location.href = '/security/login';
        }
    },
    {
        path: '/logout/sso',
        name: 'LogoutSSO',
        description: 'Logout of the SSO.',
        beforeEnter() {
            location.href = '/security/logout';
        }
    },
    {
        path: '/admin/documentation',
        name: 'Documentation',
        description: 'Documentation of the routes pages.',
        component: () => import(/* webpackChunkName: "documentation" */ '../views/Documentation.vue')
    },
    {
        path: '/admin/backoffice',
        name: 'BackOffice',
        description: 'Admin configuration page.',
        component: () => import(/* webpackChunkName: "backoffice_views" */ '../views/backoffice/Home.vue')
    },
    {
        path: '/admin/migration',
        name: 'Migration',
        description: 'Admin migration page.',
        component: () => import(/* webpackChunkName: "migration_views" */ '../views/migration/Home.vue')
    },
    {
        path: '/informations/legals',
        name: 'Footer - legals',
        description: 'Legals informations',
        component: () => import(/* webpackChunkName: "informations/legals" */ '../views/footer/Legals.vue')
    },
    {
        path: '/informations/privacyPolicy',
        name: 'Footer - privacyPolicy',
        description: 'privacyPolicy',
        component: () => import(/* webpackChunkName: "informations/privacyPolicy" */ '../views/footer/privacyPolicy.vue')
    }
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});

router.beforeEach((to, from, next) => {
    if (to.path === '/') {
        store.commit('resetClient');
    } else if (to.path === '/services') {
        store.commit('resetServices');
    }
    next();
});

export default router;
